/* eslint-disable no-useless-escape */
export const SESSION_TOKEN = 'session-token';
export const CLIENT_SIDE_ID = '62baf3989195871574e35e6c';
export const ELEMENT_ID = 'voebiz-react-attendance';
export const STRING_VALIDATE = /[^a-zA-Z ^ÂâÊêÎîÔôÛû~ÃãẼẽĨĩÕõŨũ´ÁáÉéÍíÓóÚúç\.\,\-\ ]+/;
export const EMAIL_VALIDATE = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
export const CELLPHONE_VALIDATE = /[^()0-9\-\ ]+/;
